module.exports = __webpack_public_path__ + "snow_background-6132f00064d443290a723eac05dd1382.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/snow_background.jpg
// module id = 1708
// module chunks = 1